'use client';

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../styles/Projects.module.css';
import { ClientPurchaseModal } from './ClientPurchaseModal';

const projectsData = [
  {
    id: '01-01',
    name: 'Telegram App',
    description: 'With over 62,000+ Active Users and growing, GameMax is growing the network and increasing engagement within the community through referals and Play & Earn engagements.',
    image: '/assets/Telegram-Tap-App.png'
  },
  {
    id: '01-02',
    name: 'Pickleball Training',
    description: 'Our advanced Training App will sharpen your skills and make you a force on the court. Schedule, train, and analyze your way to greatness with cutting-edge  sports science and growth tracking.',
    image: '/assets/GameMax-Training-bkgrnd.png'
  },
  {
    id: '01-03',
    name: 'Staking and Rewards',
    description: 'Stake your GAM tokens to earn exclusive rewards, unlock premium features, and participate in governance decisions that shape the future of GameMax.',
    image: '/assets/GameMax-Social-Mobile-App.png'
  },
  {
    id: '01-04',
    name: 'Liquidity Pools',
    description: 'Enhance your earning potential by contributing to our liquidity pools. By backing the platforms liquidity, token holders can earn a share of transaction fees, securing a steady stream of passive income.',
    image: '/assets/GameMax-Social-Mobile-activity.png'
  },
  {
    id: '01-05',
    name: 'Token Burn',
    description: 'By introducing the periodic token burns, we aim to reduce the overall supply and have a deflationary mechanism in place, ensuring scarcity and value appreciation over time.',
    image: '/assets/gam5.png'
  },
  {
    id: '01-06',
    name: 'Exclusive NFTs',
    description: 'Get exclusive access or opportunities to acquire unique GameMax NFTs. A blend of art, sports, and technology, these are assets with both aesthetic and potential value.',
    image: '/assets/gam6.png'
  }
];

const Projects = () => {
  const cardsRef = useRef(null);
  const footerRef = useRef(null);
  const projectRefs = useRef([]);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    const cards = cardsRef.current;
    const projectElements = projectRefs.current;
    
    if (!cards || projectElements.length === 0) return;
    
    // Get all pinned sections
    const pinnedSections = gsap.utils.toArray('.pinned');
    const lastCard = document.querySelector(`.${styles.scroll}`);
    const footer = footerRef.current;
    
    // Pin all sections except the last one
    pinnedSections.forEach((section, index) => {
      const project = section.querySelector(`.${styles.project}`);
      
      // Get the next section for endScalePoint
      const nextSection = pinnedSections[index + 1] || lastCard;
      const endScalePoint = nextSection ? 
        `top+=${nextSection.offsetTop - section.offsetTop} top` : 
        `bottom bottom`;
      
      // Pin the section
      gsap.to(section, {
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: index === pinnedSections.length - 1 ? 
            `+=${lastCard?.offsetHeight / 2 || 500}` : 
            footer ? `bottom-=${window.innerHeight}` : "+=100%",
          pin: true,
          pinSpacing: false,
          scrub: 1,
        },
      });
      
      // Scale animation for the project
      if (project) {
        gsap.fromTo(
          project,
          { scale: 1 },
          {
            scale: 0.5,
            filter: "blur(10px)",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: "top top",
              end: endScalePoint,
              scrub: 1,
            },
          }
        );
      }
    });
    
  }, []);
  
  // Add refs to pinnedRefs array
  const addToProjectRefs = (el) => {
    if (el && !projectRefs.current.includes(el)) {
      projectRefs.current.push(el);
    }
  };

  const handleBuyClick = () => {
    setShowPurchaseModal(true);
  };
  
  return (
    <section className="sticky-cards" ref={cardsRef}>
      <section className={`${styles.card} projecr-hero pinned`}></section>
      
      {projectsData.map((project, index) => (
        <section 
          key={project.id} 
          className={`${styles.card} ${index === projectsData.length - 1 ? styles.scroll : 'pinned'}`}
          ref={addToProjectRefs}
        >
          <div className={styles.project}>
            <div className={styles.projectCopy}>
              <div className={styles.projectHeader}>
                <h3>{project.name}</h3>
                
              </div>
              <p>{project.description}</p>
              <div className={styles.projectCta}>
                <div className={styles.projectCtaRow}>
                  <a href="https://wp.gam.one/pz-whitepaper" target="_blank" rel="noopener noreferrer" className={styles.cta}><span>Learn More</span></a>
                  <div className={styles.cta} onClick={handleBuyClick}><span>Buy GAM</span></div>
                </div>
              </div>
            </div>
            <div className={styles.projectImg}>
              <img src={project.image} alt={project.name} />
            </div>
          </div>
        </section>
      ))}
      
      <section className="footer" ref={footerRef}></section>
      
      <ClientPurchaseModal 
        isOpen={showPurchaseModal} 
        onClose={() => setShowPurchaseModal(false)} 
      />
    </section>
  );
};

export default Projects; 
